<script setup>
// The cancellation-policy table: one row per window, the window that applies
// right now highlighted. Shared by the cancel-my-place dialog and the date
// page's Cancellation terms dialog. Rows come from useMeetFormat().tierRows.
defineProps({
  rows: {type: Array, required: true},
});
</script>

<template>
  <div>
    <div
        v-for="row in rows"
        :key="row.label"
        class="tier-row"
        :class="{'tier-row--active': row.active, 'tier-row--free': row.percent === 0}"
    >
      <span>{{ row.label }}</span>
      <b>{{ row.percent === 0 ? 'Free' : `${row.percent}%` }}</b>
    </div>
  </div>
</template>

<style scoped lang="scss">
/* cancellation-policy rows (mockup .tier-row) */
.tier-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  padding: 9px 12px;
  border: 1px solid rgb(var(--v-theme-borderLight));
  border-radius: 10px;
  font-size: 12.5px;
  font-weight: 500;

  & + .tier-row {
    margin-top: 6px;
  }

  b {
    font-weight: 700;
  }

  &--active {
    border-color: rgb(var(--v-theme-warning));
    background: rgb(var(--v-theme-warningTint));

    &.tier-row--free {
      border-color: rgb(var(--v-theme-success));
      background: rgb(var(--v-theme-successTint));
    }
  }
}
</style>
